import React from 'react';
import MergedPage from '../components/nav/MergedPage';
import PayrollReview from './PayrollReview';
import PayrollProcess from './PayrollProcess';
import UserManual from './UserManual';

// Payroll (Sep 2026 nav restructure): Payroll Review + Process & Push + Manual as tabs.
export default function PayrollPage() {
  const tabs = [
    { key: 'review', label: 'Payroll Review', render: () => <PayrollReview /> },
    { key: 'process', label: 'Process & Push to QuickBooks', render: () => <PayrollProcess /> },
    { key: 'manual', label: 'Payroll Manual', render: () => <UserManual initialTab="payroll" embedded /> },
  ];
  return <MergedPage tabs={tabs} defaultTab="review" testId="payroll-page" />;
}
